var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assigned-list" }, [
    _vm.histories.length > 0
      ? _c("div", { staticClass: "assigned-list-title" }, [
          _vm._v(_vm._s(_vm.$t("workPermit.assignedHistory")) + ":"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ol",
      _vm._l(_vm.histories, function (item, index) {
        return _c("li", { key: index, staticClass: "assigned-list-item" }, [
          _vm._v(_vm._s(item)),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }